<template>
    <div class="about">
        <MainHeader/>
        <MainLogo/>
        <section style="background: #fff">
	   
	   <div class="container margin_60_35">
	<div class="row">
		<div class="col-md-6">
			<h3 class="nomargin_top">Welcome to Arturo’s Pizza and Pasta</h3>
			<p>
				 Arturo’s offers the finest Pizza, Pasta, Rice dishes, Ribs and side dishes to our patrons. 
			</p>
			<p>
			We use only the finest quality ingredients to make our Pizza and Pasta dishes. We have a wide variety of Pizza toppings to choose from as well as a selection of side dishes and desserts.
			</p>
			
			<p>
				 Established for over 14 years we offer Dine in, Take away & home delivery.
			</p>
			<p><b>We also offer home delivery to an 8km radius from our location, including areas below. </b></p>		
			<ul>
				<li>Bligh Park</li>
				<li>Londonderry</li>
				<li>South Windsor</li>
				<li>Windsor</li>
				<li>Hobartville</li>
				<li>Windsor Downs</li>
				<li>Clarendon</li>
				<li>Berkshire Park</li>
				<li>Richmond</li>
				<li>Elara Estate</li>
				<li>Mcgraths hill</li>
			</ul>
			
		</div>
		<div class="col-md-6 text-right hidden-sm hidden-xs">
			<img src="/img/about.jpg" alt="" class="img-responsive">
		</div>
	</div>
	<div class="col-md-12">	
		<hr>
			
		<p><b>BYO alcohol</b></p>
		<p><b>Home Delivery From 5.00PM</b></p>
		<p><b>$25 Minimum Order</b></p>
		<p>Additional Delivery charge applies to all areas.</p>
		<p>Prices, specials, menu items & opening hours are subject to change without notice. All prices include GST.</p>
		<p>Details correct as at January 2020</p>		
		<p>Delivery & Takeaway times given are approximate only. We work hard to serve you the best & unfortunately delays may sometimes occur. Thank you for your understanding</p>
		<p><span style="color: tomato">*</span> Gluten and Dairy free options now available! Additional charge apply.</p>
		<p><strong>Food Allergies:</strong> please be aware that All care is taken, when catering for special requirements. It must be noted that within the premises we handle nuts, seafood,  shellfish,  sesame seeds,  wheat flour,  eggs fungi and dairy products. Customers requests will be catered for to the best of our ability but the decision to consume a meal is the responsibility of the diner.Our establishment will not be held responsible for adverse reactions. </p>
	</div>
	<div class="clearfix"></div>
	
</div>
	   </section>   
    <PopUP/>
    <MainFooter/>

    </div>
     
</template>

<script>
import PreLoader from '@/components/PreLoader.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainLogo from '@/components/MainLogo.vue'
import PopUP from '@/components/Popup.vue'
import MainFooter from '@/components/MainFooter.vue'
export default {
    name: 'About',
     components: {
        PreLoader,
        MainHeader,
        MainLogo,
        PopUP,
        MainFooter
    },
}
</script>

<style>

</style>